import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function MeetOurLeadPhysiotherapist() {
  return <section className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="mb-4 font-display text-3xl font-bold tracking-wide md:text-4xl animate-fade-in-up">
            Meet Our Lead Physiotherapist
          </h2>
          <p className="mb-12 text-base leading-relaxed text-muted-foreground animate-fade-in-up-delay-100">
            Expert care from a qualified professional with years of experience in musculoskeletal physiotherapy.
          </p>
          
          <Card className="mx-auto max-w-3xl border border-border shadow-soft animate-fade-in-up-delay-200">
            <img src="https://immune-minnow.10web.cloud/wp-content/uploads/2025/10/Cartoon-3.png" alt="John Smith - Lead Physiotherapist" className="h-80 w-full rounded-t-lg object-cover" />
            <CardHeader>
              <CardTitle className="text-2xl">Anthony</CardTitle>
              <p className="text-sm font-medium text-primary">Clinical Specialist Physiotherapist</p>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-base leading-relaxed text-foreground">Anthony is a Clinical Specialist Physiotherapist with over 20 years’ experience in musculoskeletal health. His background spans professional sport, private practice, and advanced roles within the NHS.</p>
              <p className="text-sm leading-relaxed text-muted-foreground">"After two decades as a Physiotherapist, I’ve learned that every ache, pain and niggle has its own story — and often, a good laugh helps just as much as a good stretch.

I’ve treated professional athletes, weekend warriors, and everyday people who just want to move without pain. These days, I work as a Clinical Specialist in the NHS alongside running Align Physiotherapy here in Warmsworth, Doncaster.

My focus is simple: helping you understand your body, rebuild confidence, and get moving again — with treatments that make sense and results that last. Expect expert care, honest advice, and zero confusing medical waffle"</p>
              <div className="pt-4">
                <Link to="/ContactPage">
                  <Button size="lg" className="bg-primary text-primary-foreground font-semibold hover:bg-primary-hover shadow-soft transition-all duration-150">
                    Book a Consultation
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}